import { money } from './api';

export const propertyPriceLabel = (p: Record<string, any>) =>
  Number(p.price) > 0 ? money(p.price) : p.sourcePriceText || 'Price not specified';
export const propertyAreaLabel = (p: Record<string, any>) =>
  Number(p.area) > 0
    ? `${Number(p.area).toLocaleString('en-IN')} sq. ft.`
    : p.sourceAreaText || 'Area not specified';
export const isArchivedProperty = (p: Record<string, any>) =>
  p.availability === 'Archived' || p.qualityState === 'Archived';
export function propertyStatusLabel(p: Record<string, any>) {
  if (isArchivedProperty(p)) return 'Archived';
  if (p.sourceWithdrawn || p.availability === 'Unavailable') return 'Unavailable';
  if (p.catalogOnly)
    return p.inventoryKind === 'project' ? 'Project catalog' : 'Catalog · needs review';
  return p.availability === 'Available'
    ? 'Available'
    : p.availability === 'Limited'
      ? 'Limited availability'
      : 'Verification due';
}
export function isReadyProperty(p: Record<string, any>, now = Date.now(), staleDays = 14) {
  const age = (now - Date.parse(p.verifiedAt)) / 86400000;
  return (
    !isArchivedProperty(p) &&
    !p.catalogOnly &&
    !p.sourceWithdrawn &&
    Number(p.price) > 0 &&
    Number(p.area) > 0 &&
    p.qualityState === 'Published' &&
    ['Available', 'Limited'].includes(p.availability) &&
    Number.isFinite(age) &&
    age >= -1 &&
    age <= staleDays
  );
}
export function safeInventoryLink(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : undefined;
  } catch {
    return undefined;
  }
}
